function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 1000,
  cy: 1000,
  r: 960.952,
  fill: "white",
  stroke: "white",
  strokeWidth: 78.0966
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1076:538)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1223.26 1642.35L1311.97 1731.64M1311.97 1731.64L1222.67 1820.35M1311.97 1731.64L1400.68 1820.94M1311.97 1731.64L1401.27 1642.94M614.6 1648.58L703.31 1737.87M703.31 1737.87L614.014 1826.58M703.31 1737.87L792.02 1827.17M703.31 1737.87L792.607 1649.16M1642.35 777.006L1731.65 688.298M1731.65 688.298L1820.36 777.592M1731.65 688.298L1820.95 599.59M1731.65 688.298L1642.94 599.003M1648.57 1385.61L1737.87 1296.9M1737.87 1296.9L1826.58 1386.19M1737.87 1296.9L1827.17 1208.19M1737.87 1296.9L1649.16 1207.6M357.807 1223.19L268.511 1311.9M268.511 1311.9L179.801 1222.61M268.511 1311.9L179.215 1400.61M268.511 1311.9L357.221 1401.19M777.012 357.803L688.302 268.509M688.302 268.509L777.598 179.801M688.302 268.509L599.592 179.214M688.302 268.509L599.005 357.217M1385.64 351.589L1296.93 262.294M1296.93 262.294L1386.22 173.586M1296.93 262.294L1208.22 173M1296.93 262.294L1207.63 351.003M351.592 614.581L262.296 703.289M262.296 703.289L173.586 613.995M262.296 703.289L173 791.997M262.296 703.289L351.006 792.584",
  stroke: "white",
  strokeWidth: 61.4311
}));

function SvgXtarotX1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    viewBox: "0 0 2000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1076:538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2000,
    height: 2000
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtarotX1);
export default __webpack_public_path__ + "static/media/xtarot-x1.b112f53e.svg";
export { ForwardRef as ReactComponent };